import API from "components/Apis/API"

export const getData = async (
  setGraphData,
  setSummaryTable,
  setDetailTable,
  setHeaderInfo,
  selected,
  setHasAccess
) => {
  const url = "" + "admin/get_aging_data"
  let formData = new FormData()
  formData.append("sales", JSON.stringify(selected.sales))
  formData.append("customer", JSON.stringify(selected.customer))
  formData.append("accountManagement", JSON.stringify(selected.AM))
  const data = await API.postData(url, formData)
  if (data.has_access) {
    setSummaryTable(data.summary_data)
    setDetailTable(data.detail_data)
    setGraphData(data.graph_data)
    setHeaderInfo({
      total_count: data.header_info.total_count,
      total_amount: data.header_info.total_amount,
    })
    setHasAccess(true)
  } else {
    setHasAccess(false)
  }
}


export const fetchSelectors = async (setSelectors) => {
  const url = "admin/get_aging_data";
  const formData = new FormData();
  Object.entries(defaultSelectors()).map(([key, value]) => {
    formData.append(key, JSON.stringify(value));
  });
  const data = await API.postData(url, formData);
  if (data.has_access) {
    setSelectors({
      sales: data.sales,
      customer: data.customer,
      AM: data.accountManagement,
    });
  }
};


export const getOrderDetails = async (order_no, setInfoDisplay) => {
  const url = "" + "admin/get_aging_order_details"
  let formData = new FormData()
  formData.append("order_no", order_no)
  const data = await API.postData(url, formData)
  setInfoDisplay(data.data)
}

export const labels = ["Current", "1-30", "31-60", "61-90", "91+"]

export const defaultGraphData = [
  { value: 0, sum_amount: 0 },
  { value: 0, sum_amount: 0 },
  { value: 0, sum_amount: 0 },
  { value: 0, sum_amount: 0 },
  { value: 0, sum_amount: 0 },
]

export const backgroundColor = [
  "rgba(255, 99, 132,",
  "rgba(54, 162, 235,",
  "rgba(255, 206, 86,",
  "rgba(75, 192, 192,",
  "rgba(153, 102, 255,",
]

export const getBackgroundColor = (selectedIndex) =>
  backgroundColor.map(
    (color, index) => `${color} ${index === selectedIndex ? 1 : 0.4})`
  )

export const borderColor = [
  "rgba(255, 99, 132, 1)",
  "rgba(54, 162, 235, 1)",
  "rgba(255, 206, 86, 1)",
  "rgba(75, 192, 192, 1)",
  "rgba(153, 102, 255, 1)",
]

export const defaultSelectors = () => ({
  sales: [],
  customer: [],
  accountManagement: [],
})

export const defaultHeaderInfo = () => ({
  total_count: 0,
  total_amount: 0,
})

export const defaultSelected = () => ({
  sales: [],
  customer: [],
  AM: [],
})
